import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/hooks/use-auth';
import { useRoleCounts } from '../hooks/use-role-counts';
import { HUB_ROLES } from '../data/hub-roles';
import { RoleStackCard } from './role-stack-card';

// /team es el selector de rol. Los verifying no pintan aquí: su prompt de
// verificación vive en /team/collectors y es lo único que deben ver.
export function TeamHubPage(): ReactNode {
  const { user } = useAuth();
  const { data, isError } = useRoleCounts();
  if (user?.account_status === 'verifying')
    return <Navigate to="/team/collectors" replace />;
  return (
    <div className="flex min-h-[calc(100dvh-6rem)] items-center justify-center">
      <div className="grid w-full max-w-[44rem] grid-cols-3 gap-base sm:gap-xl">
        {HUB_ROLES.map((r) => (
          <RoleStackCard
            key={r.role}
            role={r.role}
            count={data?.[r.countKey]}
            to={r.to}
            failed={isError}
          />
        ))}
      </div>
    </div>
  );
}
